export const PROPERTY_COLORS = {
  ownProperty: {
    fill: '#10B981', // Green
    bg: 'bg-green-500',
    badge: 'bg-green-100 text-green-800',
    hoverBg: 'bg-green-50',
    border: 'border-green-500',
    ring: 'ring-green-300'
  },
  competitor: {
    fill: '#EC4AA9', // Pink
    bg: 'bg-pink-500',
    badge: 'bg-pink-100 text-pink-800',
    hoverBg: 'bg-pink-50',
    border: 'border-pink-500',
    ring: 'ring-pink-300'
  },
  market: {
    fill: '#3498DB', // Blue
    bg: 'bg-blue-500',
    badge: 'bg-blue-100 text-blue-800',
    hoverBg: 'bg-blue-50',
    border: 'border-blue-500',
    ring: 'ring-blue-300'
  }
};
